export default {
  ui: {
    dialog: {
      confirm: "确定",
      cancel: "取消",
      title: {
        dialog: "对话框",
        alert: "提示框",
        confirm: "确认提示框",
        prompt: "输入提示框",
      },
    },

    cascader: {
      pathAllLabel: "全部",
      noMatch: "无匹配数据",
      loading: "加载中",
      placeholder: "请选择",
    },

    pagination: {
      goto: "前往",
      pageSize: "条/页",
      total: "共 {total} 条",
      pageClassifier: "页",
    },

    colorpicker: {
      confirm: "确定",
      clear: "清空",
    },
    datepicker: {
      now: "此刻",
      today: "今天",
      cancel: "取消",
      clear: "清空",
      confirm: "确定",
      selectDate: "选择日期",
      selectTime: "选择时间",
      startDate: "开始日期",
      startTime: "开始时间",
      endDate: "结束日期",
      endTime: "结束时间",
      prevYear: "前一年",
      nextYear: "后一年",
      prevMonth: "上个月",
      nextMonth: "下个月",
      year: "年",
      month1: "1 月",
      month2: "2 月",
      month3: "3 月",
      month4: "4 月",
      month5: "5 月",
      month6: "6 月",
      month7: "7 月",
      month8: "8 月",
      month9: "9 月",
      month10: "10 月",
      month11: "11 月",
      month12: "12 月",
      // week: '周次',
      weeks: {
        sun: "日",
        mon: "一",
        tue: "二",
        wed: "三",
        thu: "四",
        fri: "五",
        sat: "六",
      },
      months: [
        "一月",
        "二月",
        "三月",
        "四月",
        "五月",
        "六月",
        "七月",
        "八月",
        "九月",
        "十月",
        "十一月",
        "十二月",
      ],
      shortcuts: {
        today: "今天",
        yesterday: "昨天",
        thisWeek: "本周",
        lastWeek: "上周",
        nextWeek: "下周",
        thisMonth: "本月",
        lastMonth: "上月",
        nextMonth: "下月",
        thisQuarter: "本季度",
        lastQuarter: "上季度",
        nextQuarter: "下季度",
        thisYear: "本年",
        lastYear: "上年",
      },
      format: {
        year: "yyyy年",
        month: "yyyy年MM月",
        date: "yyyy年MM月dd日",
        dateTime: "yyyy年MM月dd日 HH:mm:ss",
      },
      separator: " 至 ",
    },
    selector: {
      placeholder: "请选择",
      multiplePlaceholder: "选择更多...",
    },
    select: {
      loading: "加载中",
      noMatch: "无匹配数据",
      noData: "无数据",
    },

    autoComplete: {
      placeholder: "请输入关键字进行搜索",
    },

    messagebox: {
      title: "提示",
      confirm: "确定",
      cancel: "取消",
      error: "输入的数据不合法!",
    },
    upload: {
      delete: "删除",
      dragAndDrop: "将文件拖放到此处，或",
      click: "点击此处",
      clickUpload: "点击上传",
      startUpload: "开始上传",
      preview: "预览",
      fail: "上传失败",
      cancel: "取消",
    },
    table: {
      emptyText: "暂无数据",
      confirmFilter: "筛选",
      resetFilter: "重置",
      clearFilter: "全部",
      sumText: "合计",
    },
    tree: {
      emptyText: "暂无数据",
    },

    treeSelect: {
      loading: "加载中",
      noMatch: "无匹配数据",
      noData: "无数据",
    },

    transfer: {
      noMatch: "无匹配数据",
      noData: "无数据",
      titles: ["列表 1", "列表 2"],
      filterPlaceholder: "请输入搜索内容",
      noCheckedFormat: "共 {total} 项",
      hasCheckedFormat: "已选 {checked}/{total} 项",
    },

    colorPicker: {
      confirm: "确认",
      reset: "重置",
    },
    popconfirm: {
      confirm: "确定",
      cancel: "取消",
    },
  },
}
